export default "__VITE_ASSET__CRbzTiY5__"